<!--运营指标-->
<template>
  <div class="taskIndicators">
    <BigTitle :bigtitle="bigtitle" ></BigTitle>
    <div class="userIndicators">
      <div class="indicator" v-for="(item,index) in opList1" :key="index">
        <img class="bg" :src="item.img"/>
        <div>
          <p class="text text-xss">{{item.text}}</p>
          <p class="counts text-xl" :class="{'text-xss':index==1}">{{item.counts}}</p>
        </div>
      </div>
    </div>
    <div class="userIndicators">
      <div class="indicator" v-for="(item,index) in opList2" :key="index">
        <img class="bg" :src="item.img"/>
        <div>
          <p class="text text-xss">{{item.text}}</p>
          <p class="counts text-xl">{{item.counts}}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BigTitle from '@/components/bigTitle';
import { batteryBoxLeft } from '@/api/batteryBox/left';
import icon0 from "@/assets/images/battery/icon0.png";
import icon1 from "@/assets/images/battery/icon1.png";
import icon2 from "@/assets/images/battery/icon2.png";
import icon3 from "@/assets/images/battery/icon3.png";
import icon4 from "@/assets/images/battery/icon4.png";
  import { dataInterface } from '@/api/dataInterfaceApi';


export default {
  data () {
    return {
      options: {},
      bigtitle:{
        CHN:'充电过程电池信息',
        ENG:'Evaluation index'
      },
      opList1:[{
        text:'电池编号',counts:'',img:icon0
      },{text:'记录时间',counts:'',img:icon1},
      {text:'当前SOC(%)',counts:'',img:icon2},
      {text:'充电电流(A)',counts:'',img:icon3}],
      opList2:[{
        text:'最高单体电压(V)',counts:'',img:icon4
      },{text:'最低单体电压(V)',counts:'',img:icon4},
      {text:'当前剩余电量(kWh)',counts:'',img:icon2},
      {text:'已经充电时间(min)',counts:'',img:icon1}],
    };
  },
  components: {
    BigTitle,
  },
  props: {
    // userList: {
    //   type: Object,
    //   default: () => ({})
    // },
  },
  watch: {
    
  },
  mounted () {
  },
  methods: {
    getData(data){
      this.chargingProcessInfo(data);
    },
    chargingProcessInfo(data={}){
      let _this = this;

      let params = {
					"enCode":"TiDB-dianchixiang-chongdianguochengdianchixinxi",
          "@battery_id":data.batteryId
				}
        dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if(!res) return;
          res = res[0];
          console.log("充电过程666",res)
          _this.opList1 = [{
            text:'电池编号',counts:res.batteryNumber,img:icon0
          },{text:'记录时间',counts:res.createTime,img:icon1},
          {text:'当前SOC(%)',counts:res.currentSoc,img:icon2},
          {text:'充电电流(A)',counts:res.chgOutputCurr,img:icon3}]
          _this.opList2 = [{
            text:'最高单体电压(V)',counts:res.maximumCellVoltage,img:icon4
          },{text:'最低单体电压(V)',counts:res.minimumCellVoltage,img:icon4},
          {text:'当前剩余电量(kWh)',counts:res.currentRemainingPower||0,img:icon2},
          {text:'已经充电时间(min)',counts:res.chMinute,img:icon1}]
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }
}
</script>
<style lang="scss" scoped>


.taskIndicators{
  width:1550px;
  margin-bottom:15px;
}

.userIndicators,.opIndicators{
  // width:511px;
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
  // grid-template-rows: 50% 50%;
  background: linear-gradient(180deg, rgba(47, 164, 159, 0.11) 0%, rgba(1, 177, 169, 0.06) 79%, rgba(53, 149, 147, 0.11) 100%);
  padding-left:35px;
}
.userIndicators{
  .bg{
    width:70px;
    height:70px;
    margin-left:10px;
    margin-right:20px;
  }
  .indicator{
    display: flex;
    margin-top:20px;
    // margin-bottom:30px;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    word-break: keep-all;
    .counts{
      color: #1BBEEE;
      width:100%;
    }
    .text{
      color: #FFFFFF;
    }
  }
}
.opIndicators{
  .bg{
    width:89px;
    height:53px;
    // margin-right:20px;
  }
  .indicator{
    display: flex;
    margin-top:20px;
    // margin-bottom:30px;
    .counts{
    }
    .text{
    
    }
  }
}
.arrow{
  width:12px;
  height:18px;
}
</style>